import GlobalStatistics from "./GlobalStatistics"

export default GlobalStatistics
